var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2596 6.91675C30.4935 6.15026 29.5838 5.54222 28.5827 5.12738C27.5815 4.71254 26.5084 4.49902 25.4246 4.49902C24.3409 4.49902 23.2678 4.71254 22.2666 5.12738C21.2654 5.54222 20.3558 6.15026 19.5897 6.91675L17.9997 8.50674L16.4097 6.91675C14.8622 5.36922 12.7633 4.49983 10.5747 4.49983C8.3862 4.49983 6.28731 5.36922 4.73978 6.91675C3.19225 8.46427 2.32286 10.5632 2.32286 12.7517C2.32286 14.9402 3.19225 17.0391 4.73978 18.5867L6.32977 20.1767L17.9997 31.8466L29.6696 20.1767L31.2596 18.5867C32.0261 17.8205 32.6341 16.9109 33.049 15.9097C33.4638 14.9085 33.6773 13.8354 33.6773 12.7517C33.6773 11.668 33.4638 10.5949 33.049 9.5937C32.6341 8.59251 32.0261 7.68288 31.2596 6.91675V6.91675Z",
    stroke: "#FE4672",
    strokeWidth: 2.99998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 17.5H21.8L19.4 22L14.6 13L12.2 17.5H5",
    stroke: "#FE4672",
    strokeWidth: 2.99998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.9998,
    height: 35.9998,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/Health.50259adb020cb2dd711f4babd887f6a2.svg";
export { ForwardRef as ReactComponent };